import { useState, useCallback } from 'react';

/**
 * Encapsulates “filter events by sport or league” behaviour.
 * @param {Array<object>} completeLiveEvents - full list of events returned by /v6/events.
 * @param {Function} searchEvents - function to search events by searchTerm (for leagues)
 */

export default function useEventsFilter(completeLiveEvents = [], searchEvents) {
  const [showFiltered, setShowFiltered] = useState(false);
  const [selectedSport, setSelectedSport] = useState(null);
  const [filteredType, setFilteredType] = useState('sport');

  /**
   * Handles selection of a sport or league card.
   * @param {object} item - The selected sport or league object.
   * @param {object} [options] - Optional options: { type: 'sport' | 'league' }
   */
  const handleCardSelect = useCallback((item, options = { type: 'sport' }) => {
    if (!item || !Array.isArray(completeLiveEvents) || completeLiveEvents.length === 0) return;
    if(options.type) setFilteredType(options.type);

    setSelectedSport(item);
    setShowFiltered(true);

    let results = [];
    if (filteredType === 'league') {
      // Filter by searchTerm using searchEvents
      if (typeof searchEvents === 'function' && item.searchTerm) {
        results = searchEvents(completeLiveEvents, item.searchTerm);
      } else {
        results = [];
      }
    } else if (filteredType === 'sport') {
      // Filter by sport id (matches id in event.sports array)
      if (item.id) {
        results = completeLiveEvents.filter(ev =>
          Array.isArray(ev.sports) && ev.sports.some(s => String(s.id) === String(item.id))
        );
      } else {
        results = [];
      }
    } else {
      results = [];
    }
  }, [completeLiveEvents, searchEvents]);


  const filteredEvents = () => {
    let results = [];
    if (filteredType === 'league') {
      if (typeof searchEvents === 'function' && selectedSport.searchTerm) {
        results = searchEvents(completeLiveEvents, selectedSport.searchTerm);
      } else {
        results = [];
      }
    } else if (filteredType === 'sport') {
      if (selectedSport.id) {
        results = completeLiveEvents.filter(ev =>
          Array.isArray(ev.sports) && ev.sports.some(s => String(s.id) === String(selectedSport.id))
        );
      } else {
        results = [];
      }
    } else {
      results = [];
    }
    return results;
  }

  const resetFilter = () => {
    setShowFiltered(false);
    setSelectedSport(null);
  };

  return {
    showFiltered,
    selectedSport,
    handleCardSelect,
    resetFilter,
    filteredEvents
  };
}